<template>
    <div id="loading-area">
        
        <b-row align-h="center" align-v="center">
            <b-col md="4">

                <div v-if="showCloud" class="loading-cloud-block faa-float animated">
                    <!-- <i class="fa fa-cloud"></i> -->
                    <b-img :src="$config.getAssetsURL('img/brand/Beehive_Icon.png')" width="30" fluid alt="" />
                </div>

                <div v-if="showAgriGift" class="loading-move-block faa-passing animated">
                    <b-img :src="$config.getAssetsURL('img/brand/AgriOpenMouth.png')" width="40" fluid alt="" />
                    <i class="fa fa-gift"></i>
                </div>

                <div class="loading-text-block">
                    <i :class="getDeviceIcon"></i> {{ $t('other.loading') }}
                </div>

            </b-col>
            
        </b-row>

    </div>
</template>

<script>
export default {
    props: {
        showCloud: {
            type: Boolean,
            default: true,
        },
        showAgriGift: {
            type: Boolean,
            default: true,
        }
    },
    data () {
        return {
        }
    },
    mounted () {
        
    },
    computed: {

        getDeviceIcon ()
        {
            let _class = ''
            let _pageWidth = document.body.offsetWidth;
            // console.log( _pageWidth )
            if ( _pageWidth >= 1350 )
            {
                _class += 'fa fa-desktop'
            }
            else if ( _pageWidth >= 800 )
            {
                _class += 'fa fa-laptop'
            }
            else if ( _pageWidth >= 350 )
            {
                _class += 'cui-tablet'
            }
            else
            {
                _class += 'fa fa-mobile-phone'
            }
            return _class
        },

    }
}
</script>

<style lang="scss" scoped>

#loading-area
{
    margin: 25px 10px;
    text-align: center;
    @media only screen and (max-width: 350px)
    {
        text-align: left;
    }
}
.loading-cloud-block
{
    display: inline-block;
    text-align: center;
    font-size: 2.5rem;
    color: rgba(97, 180, 199, 0.8);
}
.loading-move-block
{
    position: absolute;
    display: inline-block;
    width: 100px;
    text-align: left;
    margin-top: 18px;
    margin-left: 35px;
    font-size: 1.2rem;
    i {
        position: absolute;
        vertical-align: bottom;
        margin-top: 12px;
        color: rgb(189, 104, 104);
    }
}
.loading-text-block
{
    display: inline-block;
    margin-top: 40px;
    margin-left: 5px;
    text-align: center;
    font-size: 1.5rem;
    i {
        font-size: 1.5rem;
    }
}

i.fa.fa-mobile-phone
{
    font-size: 1.7rem;
}

</style>
